export default __webpack_public_path__ + "static/media/invalid.b6559cf4.png";